import React from 'react'
import Logo from '@/assets/ali-ulvi.png'
import { ArrowLeft, Clock, BookOpen, Wifi } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const About = () => {
  const navigate = useNavigate()

  const workingHours = [
    { days: 'Pazartesi - Cuma', hours: '09:00 - 21:00' },
    { days: 'Cumartesi', hours: '09:00 - 21:00' },
    { days: 'Pazar', hours: 'Kapalı' },
  ]

  return (
    <div className='p-4'>
      {/* Geri */}
      <button onClick={() => navigate(-1)} className='flex items-center gap-1 text-[#AC5E2A] mb-4 active:scale-95 transition'>
        <ArrowLeft size={20} />
        <span className='text-sm font-medium'>Geri</span>
      </button>

      {/* Başlık ve Logo */}
      <div className='flex flex-col items-center text-center mb-6'>
        <div className='w-20 h-20 rounded-full overflow-hidden shadow-md mb-3'>
          <img src={Logo} alt='Logo' className='w-full h-full object-cover' />
        </div>

        <h1 className='text-xl font-bold text-[#AC5E2A]'>Ali Ulvi Kurucu Gençlik Merkezi</h1>
        <p className='text-gray-600 text-sm mt-1'>Gençlere yönelik sosyal, kültürel ve teknolojik imkanlar sunan bir merkez.</p>
      </div>

      {/* İçerik Kartı */}
      <div className='bg-white rounded-2xl border border-gray-100 p-5 space-y-3'>
        <h2 className='text-lg font-semibold text-gray-800'>Hakkında</h2>

        <p className='text-sm text-gray-700 leading-relaxed'>Ali Ulvi Kurucu Gençlik Merkezi; gençlerin eğitimden sanata, teknolojiden sosyal yaşama kadar birçok alanda kendilerini geliştirebilecekleri modern bir yaşam alanıdır.</p>

        <p className='text-sm text-gray-700 leading-relaxed'>Merkezimizde sinema salonu, PlayStation alanı, çalışma salonları, atölyeler ve çok amaçlı etkinlik alanları bulunmaktadır. Amaç, gençlerin kendilerini rahatça ifade edebilecekleri ve kaliteli vakit geçirebilecekleri bir ortam oluşturmaktır.</p>

        <p className='text-sm text-gray-700 leading-relaxed'>Tüm etkinlikler ve alanlar düzenli olarak güncellenmekte olup, gençlere daha iyi hizmet sunmak için sürekli gelişmeye devam ediyoruz.</p>
      </div>

      {/* Çalışma Saatleri */}
      <div className='bg-[#AC5E2A]/5 rounded-3xl p-6 border border-[#AC5E2A]/10 mt-6'>
        <div className='flex items-center gap-2 mb-4'>
          <div className='bg-[#AC5E2A] text-white p-2 rounded-xl'>
            <Clock size={20} />
          </div>
          <h2 className='text-lg font-bold text-gray-800'>Çalışma Saatleri</h2>
        </div>
        <div className='space-y-3'>
          {workingHours.map((item, idx) => (
            <div key={idx} className='flex justify-between items-center border-b border-[#AC5E2A]/10 pb-2 last:border-0 last:pb-0'>
              <span className='text-gray-700 font-medium text-sm'>{item.days}</span>
              <span className='text-[#AC5E2A] font-bold text-sm'>{item.hours}</span>
            </div>
          ))}
        </div>
      </div>

      {/* İmkanlar ve Hizmetler */}
      <div className='mt-6'>
        <h2 className='text-lg font-bold text-gray-800 mb-4 px-2 text-start'>İmkanlar ve Hizmetler</h2>
        <div className='grid grid-cols-1 gap-3'>
          {[
            { icon: <BookOpen size={20} />, title: 'Geniş Kitap Koleksiyonu', desc: 'Binlerce basılı ve dijital kaynak' },
            { icon: <Wifi size={20} />, title: 'Ücretsiz Wi-Fi', desc: 'Kesintisiz yüksek hızlı internet' }
          ].map((item, idx) => (
            <div key={idx} className='flex items-center gap-4 bg-white p-4 rounded-2xl border border-gray-100'>
              <div className='bg-gray-50 text-[#AC5E2A] p-3 rounded-xl'>
                {item.icon}
              </div>
              <div>
                <h2 className='text-start font-bold text-gray-800 text-sm'>{item.title}</h2>
                <p className='text-start text-gray-500 text-xs mt-0.5'>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className='text-center mt-6 text-xs text-gray-500'>© {new Date().getFullYear()} Ali Ulvi Kurucu Gençlik Merkezi</div>
    </div>
  )
}

export default About
